import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { NewProgressService, ProgressReport } from 'data/service/progress-service';
import { produce } from 'immer';

type ProgressState = {
  productId: string | null;
  isLoading: boolean;
  progress: ProgressReport;
};

const initialState: ProgressState = {
  productId: null,
  progress: <ProgressReport>{},
  isLoading: false,
};

export const NewProgressStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withMethods((store, service = inject(NewProgressService)) => {
    console.log('🟡 ProgressStore instance initialized', performance.now());

    return {
      async loadProgress(productId: string) {
        if (!store.isLoading() && store.progress() != null) {
          patchState(store, { isLoading: true });
          const progressReport = await service.loadProgress(productId);
          patchState(store, {
            isLoading: false,
            progress: progressReport ?? <ProgressReport>{},
            productId,
          });
        }
      },

      async reportProgress(
        productId: string,
        moduleId: string,
        contentId: string,
        groupId?: string
      ) {
        const reportSuccess = await service.reportModuleProgress(
          productId,
          moduleId,
          contentId,
          groupId
        );

        if (reportSuccess) {
          const timestamp = new Date().toISOString();

          patchState(
            store,
            produce((draft: ProgressState) => {
              const progress = draft.progress;

              if (groupId) {
                progress.group ??= [];
                const group = progress.group.find((g) => g.groupId === groupId) ??
                  progress.group[progress.group.push({ groupId, modules: [] }) - 1];

                const module =
                  group.modules.find((m) => m.moduleId === moduleId) ??
                  group.modules[group.modules.push({ moduleId, contents: [] }) - 1];

                const contentIdx = module.contents.findIndex((c) => c.contentId === contentId);
                if (contentIdx !== -1) {
                  module.contents[contentIdx] = { contentId, timestamp };
                } else {
                  module.contents.push({ contentId, timestamp });
                }
              } else {
                progress.individual ??= [];
                const module =
                  progress.individual.find((m) => m.moduleId === moduleId) ??
                  progress.individual[
                    progress.individual.push({ moduleId, contents: [] }) - 1
                  ];

                const contentIdx = module.contents.findIndex((c) => c.contentId === contentId);
                if (contentIdx !== -1) {
                  module.contents[contentIdx] = { contentId, timestamp };
                } else {
                  module.contents.push({ contentId, timestamp });
                }
              }
            })
          );
        }

        return reportSuccess;
      },
    };
  })
);
